import { AxiosRequestConfig } from "axios";


// Basic bearer token auth headers 
export const BEARER = 'bearer';
export const COOKIE = 'cookie';
export const NO_OP = 'noop';
export const JWT = 'jwt';

export const X_AUTH_LENDSMART_NAMESPACE = 'X-AUTH-LENDSMART-NAMESPACE'
export const X_AUTH_LENDSMART_EMAIL = 'X-AUTH-LENDSMART-EMAIL'
export const X_AUTH_LENDSMART_COOKIE_EMAIL = 'X-AUTH-LENDSMART-COOKIE-EMAIL'


export type AuthProvider = "bearer" |
    "cookie" |
    "noop"


export interface AuthConfig {
    provider: AuthProvider;
    expiresAt: string;
    config: any;
}

export interface Authenticator {
    // constructor(auth: AuthConfig): void;

    isAuthProvider(): boolean;
    shouldRefresh(): boolean;

    applyAuthentication(
        auth: AxiosRequestConfig,
        opts?: any,
    ): AxiosRequestConfig;

    refreshAuthentication(): Promise<void>;

}